export default {
	input: 'w-full p-2 border',
};
